module.exports = __webpack_public_path__ + "assets/452099b6bb72f725e17f86b4ad69bfb5.mp3";